import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'

import AppErrorBoundaryFallback from './common/AppErrorBoundaryFallback'
import MainLayout from './layouts/MainLayout'

export enum RoutePaths {
  Root = '/',
  LiquidityPoolsList = '/liquidity-pools',
  LiquidityPoolsItem = '/liquidity-pools/:token0/:token1',
  Explore = '/explore',
}

export const createRouter = () => {
  const Swap = lazy(() => import('@/pages/Swap'))
  const LiquidityPools = lazy(() => import('@/pages/LiquidityPools/pages/List'))
  const LiquidityPoolsItem = lazy(
    () => import('@/pages/LiquidityPools/pages/Item'),
  )
  const Explore = lazy(() => import('@/pages/Explore'))

  return createBrowserRouter([
    {
      path: RoutePaths.Root,
      ErrorBoundary: () => (
        <AppErrorBoundaryFallback onReset={() => window.location.reload()} />
      ),
      element: (
        <MainLayout>
          <Suspense fallback={<></>}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),
      children: [
        {
          path: RoutePaths.Root,
          element: <Swap />,
        },
        {
          path: RoutePaths.LiquidityPoolsList,
          element: <LiquidityPools />,
        },
        {
          path: RoutePaths.LiquidityPoolsItem,
          element: <LiquidityPoolsItem />,
        },
        {
          path: RoutePaths.Explore,
          element: <Explore />,
        },
        {
          path: '*',
          element: <Navigate replace to={RoutePaths.Root} />,
        },
      ],
    },
  ])
}
